(function () {
  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getSelectedVariantId(formId) {
    var form = document.getElementById(formId);
    if (!form) return null;
    var select = form.querySelector('[data-product-select]');
    if (select && select.value) return select.value;
    var radios = form.querySelectorAll('input[name="id"]:checked');
    if (radios.length) return radios[0].value;
    var hidden = form.querySelector('input[name="id"]');
    if (hidden) return hidden.value;
    return null;
  }

  function findVariantById(variants, id) {
    id = parseInt(id, 10);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function optionValues(variant) {
    return [variant.option1, variant.option2, variant.option3];
  }

  function findFitTypeIndex(variants) {
    for (var i = 0; i < variants.length; i++) {
      var opts = optionValues(variants[i]);
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] === 'Custom Size') return j;
      }
    }
    return -1;
  }

  function findMatchingCustomVariant(variants, fitTypeIndex, referenceVariant) {
    if (fitTypeIndex === -1) return null;
    var refOpts = optionValues(referenceVariant);
    for (var i = 0; i < variants.length; i++) {
      var opts = optionValues(variants[i]);
      var matches = true;
      for (var j = 0; j < 3; j++) {
        if (j === fitTypeIndex) continue;
        if (opts[j] !== refOpts[j]) { matches = false; break; }
      }
      if (matches && opts[fitTypeIndex] === 'Custom Size') return variants[i];
    }
    return null;
  }

  // --- Consult tab "Request a Callback" -----------------------------
  // Real, native Shopify {% form 'contact' %} - submissions email the
  // store's Notifications recipient exactly as they always did. The
  // button is type="button", not type="submit", and clicking it calls
  // the form's native .submit() DOM method directly - per spec this
  // performs a real page submission WITHOUT ever firing a "submit"
  // event, so third-party scripts that hook the submit event never see
  // it. Shopify's own bot/fraud verification on /contact can still
  // occasionally challenge a submission - that's platform-level and out
  // of theme code's control, which is why "Send via WhatsApp Instead"
  // exists as a guaranteed-delivery fallback using the same fields.
  function initConsultForm(wrap) {
    if (!wrap || wrap.getAttribute('data-consult-wired') === 'true') return;
    wrap.setAttribute('data-consult-wired', 'true');

    var form = wrap.querySelector('form.bespoke-consult__form');
    if (!form) return;

    var submitBtn = form.querySelector('[data-consult-submit]');
    var whatsappBtn = form.querySelector('[data-consult-whatsapp]');
    var errorEl = form.querySelector('[data-consult-error]');
    var whatsappNumber = wrap.getAttribute('data-whatsapp-number');
    var productLine = wrap.getAttribute('data-product-line');

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    function validate() {
      var nameInput = form.querySelector('[name="contact[name]"]');
      var phoneInput = form.querySelector('[name="contact[phone]"]');

      setError('');

      if (!nameInput || !nameInput.value.trim()) {
        setError('Please enter your name.');
        if (nameInput) nameInput.focus();
        return null;
      }
      if (!phoneInput || !phoneInput.value.trim()) {
        setError('Please enter a phone number or email.');
        if (phoneInput) phoneInput.focus();
        return null;
      }
      return { name: nameInput.value.trim(), phone: phoneInput.value.trim() };
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!validate()) return;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
        // Native .submit() - bypasses the "submit" event entirely, so
        // no event-based listener anywhere on the page (Vitals or
        // otherwise) ever gets a chance to intercept this.
        form.submit();
      });
    }

    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', function () {
        var fields = validate();
        if (!fields) return;

        var timeInput = form.querySelector('[name="contact[body]"]');
        var lines = [
          'Hi ZOQ Leather, I would like a Custom Size consultation for: ' + productLine,
          'Name: ' + fields.name,
          'Contact: ' + fields.phone
        ];
        if (timeInput && timeInput.value.trim()) {
          lines.push('Best time to reach me: ' + timeInput.value.trim());
        }

        var url = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(lines.join('\n'));
        window.open(url, '_blank', 'noopener');
      });
    }
  }

  // If this page just loaded as the result of a successful consult
  // submission (form.posted_successfully? was true server-side), the
  // liquid renders data-consult-just-posted="true" on the modal. Since
  // the whole page reloaded, all modal/tab state reset - reopen it
  // straight to the consult tab so the "Thank you" message is actually
  // visible instead of hidden inside a closed modal.
  function reopenModalIfJustPosted(block, modal) {
    if (modal.getAttribute('data-consult-just-posted') !== 'true') return;
    var openBtn = block.querySelector('[data-bespoke-open]');
    var header = block.querySelector('[data-bespoke-header]');
    var consultTab = modal.querySelector('[data-bespoke-tab="consult"]');
    var tabs = modal.querySelectorAll('[data-bespoke-tab]');
    var panes = modal.querySelectorAll('[data-bespoke-pane]');
    var footerEl = modal.querySelector('[data-bespoke-footer]');

    block.classList.add('is-active');
    if (header) header.setAttribute('aria-expanded', 'true');

    tabs.forEach(function (t) { t.classList.remove('is-active'); });
    panes.forEach(function (p) { p.classList.remove('is-active'); });
    if (consultTab) consultTab.classList.add('is-active');
    var consultPane = modal.querySelector('[data-bespoke-pane="consult"]');
    if (consultPane) consultPane.classList.add('is-active');
    if (footerEl) footerEl.style.display = 'none';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (openBtn) openBtn.scrollIntoView({ block: 'center' });
  }

  function initBespokeBlock(block) {
    var uid = block.getAttribute('data-bespoke-uid');
    var modal = document.querySelector('.bespoke-modal[data-bespoke-uid="' + uid + '"]');
    if (!modal) return;

    var consultWrap = modal.querySelector('.bespoke-consult__wrap');
    initConsultForm(consultWrap);
    reopenModalIfJustPosted(block, modal);

    var variantsScript = block.querySelector('[data-bespoke-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var fitTypeIndex = findFitTypeIndex(variants);

    var header = block.querySelector('[data-bespoke-header]');
    var openBtn = block.querySelector('[data-bespoke-open]');
    var openBtnDefaultLabel = openBtn.textContent;
    var closeBtn = modal.querySelector('[data-bespoke-close]');
    var submitBtn = modal.querySelector('[data-bespoke-submit]');
    var errorEl = modal.querySelector('[data-bespoke-error]');
    var priceEl = block.querySelector('[data-bespoke-price]');
    var summaryEl = block.querySelector('[data-bespoke-summary]');
    var footerEl = modal.querySelector('[data-bespoke-footer]');
    var selectedBadge = block.querySelector('[data-bespoke-selected-badge]');

    var formId = block.getAttribute('data-form-id');
    var form = document.getElementById(formId);

    function getCurrentVariant() {
      var selectedId = getSelectedVariantId(formId);
      return selectedId ? findVariantById(variants, selectedId) : null;
    }

    function isCustomSelected() {
      var current = getCurrentVariant();
      if (!current || fitTypeIndex === -1) return false;
      return optionValues(current)[fitTypeIndex] === 'Custom Size';
    }

    function updateSelectedState() {
      var selected = isCustomSelected();
      block.classList.toggle('is-selected', selected);
      if (selectedBadge) selectedBadge.hidden = !selected;
      openBtn.classList.toggle('is-selected', selected);
      openBtn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      openBtn.textContent = selected ? '✓ Custom Size Selected — Edit Details' : openBtnDefaultLabel;
    }

    function refreshPricePreview() {
      var current = getCurrentVariant();
      if (!current) return;
      var custom = findMatchingCustomVariant(variants, fitTypeIndex, current);
      if (priceEl) priceEl.textContent = formatMoney(custom ? custom.price : current.price);
    }

    function expandPanel() {
      if (block.classList.contains('is-active')) return;
      block.classList.add('is-active');
      header.setAttribute('aria-expanded', 'true');
    }

    function selectCustomSizeVariant() {
      if (isCustomSelected()) return;
      var radio = document.querySelector('.variant-input[data-value="Custom Size"] input[data-variant-input]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function toggle() {
      var active = block.classList.toggle('is-active');
      header.setAttribute('aria-expanded', active ? 'true' : 'false');
      refreshPricePreview();
      updateSelectedState();
    }

    header.addEventListener('click', toggle);
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    function openModal() {
      refreshPricePreview();
      updateSelectedState();
      expandPanel();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    var tabs = modal.querySelectorAll('[data-bespoke-tab]');
    var panes = modal.querySelectorAll('[data-bespoke-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabName = tab.getAttribute('data-bespoke-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panes.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        modal.querySelector('[data-bespoke-pane="' + tabName + '"]').classList.add('is-active');

        if (footerEl) {
          footerEl.style.display = (tabName === 'consult') ? 'none' : '';
        }
      });
    });

    var measureInputs = modal.querySelectorAll('[data-measure-target]');
    measureInputs.forEach(function (input) {
      var target = input.getAttribute('data-measure-target');
      var line = modal.querySelector('.bespoke-measure-line[data-measure="' + target + '"]');
      if (!line) return;
      input.addEventListener('focus', function () { line.classList.add('is-active'); });
      input.addEventListener('blur', function () { line.classList.remove('is-active'); });
    });

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    function activeTabName() {
      var activeTab = modal.querySelector('.bespoke-tab.is-active');
      return activeTab ? activeTab.getAttribute('data-bespoke-tab') : 'measure';
    }

    function collectProperties() {
      var mode = activeTabName();
      var props = {
        'Custom Size': 'Yes',
        'Estimated Ship Time': '2-3 weeks'
      };

      if (mode === 'consult') {
        props['Fit Method'] = 'Consultation Requested';
        return { properties: props };
      }

      props['Fit Method'] = mode === 'measure' ? 'Exact Measurements' : 'Standard Size + Adjustments';

      if (mode === 'measure') {
        var chest = modal.querySelector('[data-bespoke-field="chest"]').value;
        var shoulder = modal.querySelector('[data-bespoke-field="shoulder"]').value;
        var sleeve = modal.querySelector('[data-bespoke-field="sleeve"]').value;
        var length = modal.querySelector('[data-bespoke-field="length"]').value;
        var preference = modal.querySelector('[data-bespoke-field="preference"]').value;

        if (!chest || !shoulder || !sleeve || !length) {
          var missing = !chest ? 'chest' : (!shoulder ? 'shoulder' : (!sleeve ? 'sleeve' : 'length'));
          return { error: 'Please provide all four measurements, or switch to "Adjust My Usual Size."', field: missing };
        }

        props['Chest (in)'] = chest;
        props['Shoulder (in)'] = shoulder;
        props['Sleeve Length (in)'] = sleeve;
        props['Jacket Length (in)'] = length;
        props['Fit Preference'] = preference;
      } else {
        var refsize = modal.querySelector('[data-bespoke-field="refsize"]').value;
        var notes = modal.querySelector('[data-bespoke-field="notes"]').value;

        if (!notes || notes.trim().length < 3) {
          return { error: 'Please describe at least one adjustment, or switch to "Provide My Measurements."', field: 'notes' };
        }

        props['Reference Size'] = refsize;
        props['Adjustment Notes'] = notes.trim();
      }

      return { properties: props };
    }

    function clearHiddenProperties() {
      document.querySelectorAll('[data-bespoke-property="' + block.id + '"]').forEach(function (el) { el.remove(); });
    }

    function syncHiddenProperties(props) {
      clearHiddenProperties();
      if (!props || !form) return;
      Object.keys(props).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = props[key];
        input.setAttribute('form', formId);
        input.setAttribute('data-bespoke-property', block.id);
        document.body.appendChild(input);
      });
    }

    function renderSummary(props) {
      var lines = [];
      Object.keys(props).forEach(function (key) {
        if (key === 'Custom Size') return;
        lines.push('<strong>' + key + ':</strong> ' + props[key]);
      });
      summaryEl.innerHTML = '✓ Fit confirmed, ' + lines.join(' &middot; ');
      summaryEl.hidden = false;
    }

    submitBtn.addEventListener('click', function () {
      if (activeTabName() === 'consult') {
        closeModal();
        return;
      }

      clearError();
      var result = collectProperties();
      if (result.error) {
        showError(result.error);
        var fieldEl = modal.querySelector('[data-bespoke-field="' + result.field + '"]');
        if (fieldEl) fieldEl.focus();
        return;
      }

      selectCustomSizeVariant();
      syncHiddenProperties(result.properties);
      renderSummary(result.properties);
      updateSelectedState();
      closeModal();
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-variant-input]')) return;
      refreshPricePreview();
      updateSelectedState();
      if (isCustomSelected()) {
        expandPanel();
      } else {
        clearHiddenProperties();
        summaryEl.hidden = true;
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isCustomSelected()) return;
        var hasSaved = document.querySelector('[data-bespoke-property="' + block.id + '"]');
        if (!hasSaved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          expandPanel();
          openModal();
        }
      }, true);
    }

    refreshPricePreview();
    updateSelectedState();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bespoke]').forEach(initBespokeBlock);
  });
})();
